import { querySelectorAll } from 'kagekiri';

export function isShadowRoot(node: Node): node is ShadowRoot {
  return 'host' in node;
}

export function isNode(node: any): node is Node {
  return 'getRootNode' in node;
}

export function elementHost(element: Element | EventTarget) {
  if (!isNode(element)) return;
  const root = element.getRootNode();
  if (isShadowRoot(root)) return root.host;
}

export function hostAndChildren(host: HTMLElement, excludeSelectors: Array<string> = []) {
  const exclude = excludeSelectors.length ? `:not(${excludeSelectors.join(',')})` : '';
  return [host, querySelectorAll(`*${exclude}`, host)].flat();
}

// Get all the matching parent elements, no matter where they are in the light/shadow DOM.
export function closestAll(element: Element, filter = '*', lineage: Element[] = []): Element[] {
  if (!element) return lineage;
  if (element.matches(filter)) lineage.push(element);

  const parent = element.assignedSlot || element.parentElement || elementHost(element);
  return parent ? closestAll(parent, filter, lineage) : lineage;
}

export function closest(element: Element, filter = '*'): Element | undefined {
  if (!element) return;
  if (element.matches(filter)) return element;

  const parent = element.assignedSlot || element.parentElement || elementHost(element);
  return parent ? closest(parent, filter) : undefined;
}

// Get the active element, no matter if it is in the document, or any shadow root.
export function getActiveElement() {
  let activeElement = document.activeElement;
  while (activeElement && activeElement.shadowRoot && activeElement.shadowRoot.activeElement) {
    activeElement = activeElement.shadowRoot.activeElement;
  }
  return activeElement;
}
